import { COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_5_TO_PRINT, COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_5 } from './constantesReporteEmbarqueSector12Linea5'
import { TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_5 } from '../../../../../../config/tables'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import { ReporteEmbarqueSector12Linea5Service } from '../../../../../../models/movimiento/ReporteEmbarquePorSector/tabla_reporte_embarque_sector_12_linea_5'

export function actualizarDatosParaMuiTable (cereal, cerealVariedad, etiqueta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_5
    })
    const promiseReporteEmbarqueSector12Linea5 = ReporteEmbarqueSector12Linea5Service.getDataReporteEmbarqueSector12Linea5(cereal, cerealVariedad, etiqueta)
    const promiseReporteEmbarqueSector12Linea5Total = ReporteEmbarqueSector12Linea5Service.getDataReporteEmbarqueSector12Linea5Total(cereal, cerealVariedad, etiqueta)
    Promise.all([promiseReporteEmbarqueSector12Linea5, promiseReporteEmbarqueSector12Linea5Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = (dataArray[1] || [])[0] || {}
      filaTotalArreglada['silo'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Reporte Embarque Sector 1-2 Linea 5',
        dataCombinada,
        COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_5_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_REPORTE_EMBARQUE_SECTOR_12_LINEA_5,
          data: dataCombinada,
          title: `Reporte Embarque Sector 1-2 Linea 5`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false }
        },
        id: TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_5
      })
    }
  }
}
